// extracted by mini-css-extract-plugin
export default {"mapWrapper":"MapWrapper_mapWrapper__e93x2"};